export default __webpack_public_path__ + "static/media/iv_user.113efbc8.svg";